import React, { useEffect, useState } from "react";
import {
  Button,
  Layout,
  Row,
  Col,
  Input,
  Form,
  Card,
  message,
  InputNumber,
  Popconfirm,
  Spin,
  Breadcrumb,
  Empty,
  Modal,
} from "antd";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import "../systemSetting/styles/index.less";
import {
  api_settingDeleteCheckTask,
  setting_all,
  setting_create,
} from "../../services/setting";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { taskClearResources } from "../../services/task";

const { Content } = Layout;

type Props = {};

const SystemSetting = (props: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMachineIndex, setSelectedMachineIndex] = useState(0);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const watchedResources = Form.useWatch("resources", form);

  // search
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getSetting();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const getSetting = async () => {
    try {
      const res = await setting_all();
      if (res.data[0]) {
        const settings: any = JSON.parse(res.data[0].setting);
        const configs_data: any = JSON.parse(res.data[0].configs);
        const chatbot_arena_url = res.data[0].chatbot_arena_url || "";
        const exptoken = configs_data.exptoken || 1;
        const time_starttask = configs_data.time_start_task || "";
        const formattedData = {
          resources: settings?.map((resource: any) => ({
            id: resource.id || null,
            hostname: resource.hostname || "",
            ip: resource.ip || "",
            preset: resource.preset || "",
            cpu: (resource.detail.cpu || []).map((cpuItem: any) => ({
              name: cpuItem.name || "",
              core: cpuItem.core ? cpuItem.core : 0,
            })),
            gpu: (resource.detail.gpu || []).map((gpuItem: any) => ({
              name: gpuItem.name || "",
              card: gpuItem.card ? gpuItem.card : 0,
            })),
            ram: resource.detail.ram ? resource.detail.ram : 0,
          })),
          chatbot_arena_url,
          exptoken,
          time_starttask,
        };
        form.setFieldsValue(formattedData);
      } else {
        message.warning(t("Unable to display data"));
        // console.warn("No data received from API.");
      }
    } catch (error) {
      message.error(t("Error fetching settings"));
      // console.error("Error fetching settings:", error);
    }
  };

  // create setting
  const systemSet = async () => {
    try {
      const values = form.getFieldsValue();
      console.log("values ::", values);
      const saveData = {
        setting: (values.resources || []).map((resource: any) => {
          let preset_id = uuidv4();
          return {
            id: resource.id || preset_id,
            hostname: resource.hostname || "",
            ip: resource.ip || "",
            preset: resource.preset || "",
            detail: {
              cpu: (resource.cpu || []).map((cpuItem: any) => ({
                name: cpuItem.name || "",
                core: parseInt(cpuItem.core, 10) || 0,
              })),
              gpu: (resource.gpu || []).map((gpuItem: any) => ({
                name: gpuItem.name || "",
                card: parseInt(gpuItem.card, 10) || 0,
              })),
              ram: parseInt(resource.ram, 10) || 0,
            },
            task_used: [],
          };
        }),
        chatbot_arena_url: values.chatbot_arena_url,
        configs: {
          exptoken: parseInt(values.exptoken, 10) || 0,
          time_start_task: values.time_starttask,
        },
      };
      const res = await setting_create(saveData);
      if (res?.status === "success") {
        message.success(t("Settings saved successfully"));
      } else {
        message.error(res?.message || t("Failed to save settings"));
      }
    } catch (error) {
      message.error(t("An error occurred while saving settings"));
    }
  };

  // validate form
  const numberInputProps = () => ({
    parser: (value: any) => value?.replace(/[^\d]/g, ""),
    formatter: (value: any) => (value ? `${value}`.replace(/\D/g, "") : ""),
    step: 1,
    onKeyPress: (event: any) => {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
  });

  // notification delete hostname
  const DeleteButtonWithConfirm = ({ onDelete = () => {}, fieldKey }: any) => {
    const v = form.getFieldsValue();
    const check = v?.resources ? v?.resources[fieldKey]?.id : null;
    console.log("fielcheckdKey", check);
    return (
      <Popconfirm
        title={t("Alert delete title")}
        description={t("Alert delete detail")}
        onConfirm={onDelete}
        okText={t("yes")}
        cancelText={t("no")}
      >
        <Button
          type="primary"
          danger
          icon={<DeleteOutlined />}
          disabled={check ? false : true}
        >
          {t("Delete host")}
        </Button>
      </Popconfirm>
    );
  };

  const handleDeleteCheckTask = async (id: any, remove: any, field: any) => {
    try {
      const res = await api_settingDeleteCheckTask({ id: id });
      if (res.status) {
        const dataTask = res.data;
        Modal.confirm({
          title:
            "Preset นี้กำลังถูกใช้งานใน Task อื่นอยู่ คุณยังคงต้องการลบ Preset นี้หรือไม่",
          width: 650,
          content: (
            <>
              <div style={{ height: "200px", overflowY: "auto" }}>
                <ul>
                  {res.data.map((item: any) => {
                    return <li style={{ fontSize: "12pt" }}>{item.name}</li>;
                  })}
                </ul>
              </div>
              {/* <Row gutter={16}>
              {res.data.map((item: any) => {
                return (
                  <Col>
                    <Button
                      type="link"
                      onClick={() => navigate(`/task/edit/${item.task_id}`)}
                    >
                      {item.name}
                    </Button>
                  </Col>
                );
              })}
            </Row> */}
            </>
          ),

          okText: "ลบ",
          cancelText: "ยกเลิก",
          okType: "danger",
          onOk: async () => {
            try {
              remove(field.name);
              setSelectedMachineIndex(Math.max(0, selectedMachineIndex - 1));
              // const data_result = dataTask.map((item: any) => item.task_id);
              // const res = await taskClearResources(data_result);
              // if (res.status) {
              //   message.success("ลบของมูล resources ของ task เรียบร้อย");
              // }
              return 1;
            } catch (error) {
              message.error("เกิดข้อผิดพลาดในการลบทีม");
            }
          },
        });
      } else {
        message.error(t("Error Delete Preset"));
      }
    } catch (e) {
      console.error(e);
    }
  };

  // confirm sub menu for cpu , gpu
  const DeleteButtonWithConfirmsub = ({ onDelete = () => {} }) => (
    <Popconfirm
      title={t("Alert delete title")}
      description={t("Alert delete detail")}
      onConfirm={onDelete}
      okText={t("yes")}
      cancelText={t("no")}
    >
      <DeleteOutlined
        style={{
          color: "red",
          cursor: "pointer",
          paddingBottom: "25px",
        }}
      />
    </Popconfirm>
  );

  // ดักเรื่องเวลา
  const handleTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, "");
    const segments = value.split(":");
    if (segments.length > 3) return;
    if (/^([01]?\d|2[0-3])?(:([0-5]?\d)?)?(:([0-5]?\d)?)?$/.test(value)) {
      setValue(value);
    }
  };

  // check ช่องว่าง
  const validateNoWhitespace = (_: any, value: string) => {
    if (!value || value.trim() === "") {
      return Promise.reject("กรุณากรอกข้อมูลให้ถูกต้อง ห้ามเป็นช่องว่าง");
    }
    return Promise.resolve();
  };

  // check preset ซ้ำกัน
  const validateUniquePreset = (_: any, value: string, index: number) => {
    if (!value) {
      return Promise.resolve();
    }
    const resources = form.getFieldValue("resources") || [];
    const presets = resources
      .map((resource: any, idx: number) => ({
        preset: resource?.preset?.trim(),
        index: idx,
      }))
      .filter((item: any) => item.preset && item.index !== index);

    const isDuplicate = presets.some(
      (item: any) => item.preset === value.trim(),
    );

    if (isDuplicate) {
      return Promise.reject("Preset นี้ถูกใช้งานแล้ว กรุณาใช้ชื่ออื่น");
    }
    return Promise.resolve();
  };

  return (
    <Layout>
      <Content className="setting-head">
        <div>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {t("System Setting")}
                    </span>
                  ),
                },
              ]}
            />
          </Row>
          <hr />
        </div>
      </Content>

      {/* body */}
      {isLoading ? (
        <Row justify="center" align="middle" style={{ height: "50vh" }}>
          <Spin size="large" />
        </Row>
      ) : (
        <Content className="setting-layout">
          <Form
            form={form}
            onFinish={systemSet}
            layout="horizontal"
            labelCol={{ flex: "250px" }}
            labelAlign="left"
            autoComplete="off"
            initialValues={{ resources: [{}], exptoken: "6" }}
          >
            <Card title={t("config")}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label={t("Email Token Expiry")}
                    name="exptoken"
                    rules={[
                      {
                        required: true,
                        message: t("Please enter the new token time"),
                      },
                    ]}
                  >
                    <InputNumber
                      min={1}
                      addonAfter={t("hour")}
                      max={1000000}
                      placeholder="1"
                      {...numberInputProps()}
                    />
                  </Form.Item>
                </Col>

                {/* <Col span={18}>
                  <Form.Item
                    label="Link Chatbot Arena"
                    name="chatbot_arena_url"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกลิงค์ chatbot arena",
                      },
                      { validator: validateNoWhitespace },
                    ]}
                  >
                    <Input placeholder="www.chatbotarena.com" />
                  </Form.Item>
                </Col> */}

                <Col span={10}>
                  <Form.Item
                    label={t("New job start time")}
                    name="time_starttask"
                    rules={[
                      {
                        required: true,
                        message: t("Please enter the job default value"),
                      },
                      {
                        pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                        message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
                      },
                      {
                        pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                        message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("placeholder enter the time")}
                      onChange={(e) =>
                        handleTimeChange(e, (value) =>
                          form.setFieldsValue({ time_starttask: value }),
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card title={t("resources")} style={{ marginTop: 10 }}>
              <Form.List name="resources">
                {(fields, { add, remove }) => (
                  <Row gutter={0} style={{ minHeight: 400 }}>
                    {/* Sidebar */}
                    <Col span={6} className="machine-sidebar">
                      <div className="machine-sidebar-list">
                        {fields.length === 0 && (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={t("No machines")}
                            style={{ padding: "20px 0" }}
                          />
                        )}
                        {fields.map((field, index) => {
                          const preset =
                            watchedResources?.[index]?.preset ||
                            `Machine ${index + 1}`;
                          const ip = watchedResources?.[index]?.ip || "";
                          const isActive = index === selectedMachineIndex;
                          return (
                            <div
                              key={field.key}
                              className={`machine-sidebar-item ${isActive ? "machine-sidebar-item--active" : ""}`}
                              onClick={() => setSelectedMachineIndex(index)}
                            >
                              <div className="machine-sidebar-item__preset">
                                {preset}
                              </div>
                              {ip && (
                                <div className="machine-sidebar-item__ip">
                                  {ip}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <Button
                        onClick={() => {
                          add();
                          setSelectedMachineIndex(fields.length);
                        }}
                        type="dashed"
                        icon={<PlusCircleOutlined />}
                        style={{ width: "100%", marginTop: 8 }}
                      >
                        {t("Add Machine")}
                      </Button>
                    </Col>

                    {/* Detail Panel */}
                    <Col span={18} className="machine-detail-panel">
                      {fields.length === 0 ? (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={t("Add Machine")}
                          style={{ marginTop: 80 }}
                        />
                      ) : (
                        fields.map((field, index) => (
                          <div
                            key={field.key}
                            style={{
                              display:
                                index === selectedMachineIndex
                                  ? "block"
                                  : "none",
                              padding: "0 24px",
                            }}
                          >
                            <>
                              {/* Preset */}
                              <Form.Item
                                name={[field.name, "preset"]}
                                label="Preset"
                                rules={[
                                  {
                                    required: true,
                                    message: "กรุณากรอก Preset",
                                  },
                                  { validator: validateNoWhitespace },
                                  {
                                    validator: (_: any, value: any) =>
                                      validateUniquePreset(_, value, index),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="ระบุ Preset"
                                  onChange={() => {
                                    const resources =
                                      form.getFieldValue("resources") || [];
                                    resources.forEach((_: any, idx: number) => {
                                      form.validateFields([
                                        ["resources", idx, "preset"],
                                      ]);
                                    });
                                  }}
                                />
                              </Form.Item>

                              {/* IP Address */}
                              <Form.Item
                                name={[field.name, "ip"]}
                                label="IP Address"
                                rules={[
                                  {
                                    required: true,
                                    message: "กรุณากรอก IP Address",
                                  },
                                  { validator: validateNoWhitespace },
                                ]}
                              >
                                <Input placeholder="ระบุ IP Address เช่น 192.168.1.1" />
                              </Form.Item>

                              {/* Hostname */}
                              <Form.Item
                                name={[field.name, "hostname"]}
                                label={t("Machine name")}
                                rules={[
                                  {
                                    required: true,
                                    message: "กรุณากรอกชื่อเครื่อง",
                                  },
                                  { validator: validateNoWhitespace },
                                ]}
                              >
                                <Input
                                  placeholder={t("placeholder enter Machine")}
                                />
                              </Form.Item>

                              {/* CPU List */}
                              <Form.Item label={t("processor")}>
                                <Form.List name={[field.name, "cpu"]}>
                                  {(cpuFields, cpuOpt) => (
                                    <div>
                                      {cpuFields.map((cpuField) => (
                                        <Row
                                          key={cpuField.key}
                                          gutter={16}
                                          align="middle"
                                        >
                                          <Col span={16}>
                                            <Form.Item
                                              name={[cpuField.name, "name"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "กรุณากรอกชื่อ CPU",
                                                },
                                                {
                                                  validator:
                                                    validateNoWhitespace,
                                                },
                                              ]}
                                            >
                                              <Input
                                                placeholder={t(
                                                  "placeholder enter cpu",
                                                )}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item
                                              name={[cpuField.name, "core"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "กรุณากรอกจำนวน Core",
                                                },
                                              ]}
                                            >
                                              <InputNumber
                                                min={1}
                                                max={10000000}
                                                placeholder="1"
                                                addonAfter="Core"
                                                {...numberInputProps()}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={2}>
                                            <DeleteButtonWithConfirmsub
                                              onDelete={() =>
                                                cpuOpt.remove(cpuField.name)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ))}
                                      {/* <Button
                                        onClick={() => cpuOpt.add()}
                                        type="dashed"
                                        icon={<PlusCircleOutlined />}
                                      >
                                        {t("Add CPU")}
                                      </Button> */}
                                    </div>
                                  )}
                                </Form.List>
                              </Form.Item>

                              {/* RAM */}
                              <Form.Item
                                label={t("Memory")}
                                name={[field.name, "ram"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "กรุณากรอกขนาด RAM",
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={1}
                                  max={10000000}
                                  placeholder="1"
                                  addonAfter="GB"
                                  {...numberInputProps()}
                                />
                              </Form.Item>

                              {/* GPU List */}
                              <Form.Item label={t("Graphics processing unit")}>
                                <Form.List name={[field.name, "gpu"]}>
                                  {(gpuFields, gpuOpt) => (
                                    <div>
                                      {gpuFields.map((gpuField) => (
                                        <Row
                                          key={gpuField.key}
                                          gutter={16}
                                          align="middle"
                                        >
                                          <Col span={16}>
                                            <Form.Item
                                              name={[gpuField.name, "name"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "กรุณากรอกชื่อ GPU",
                                                },
                                                {
                                                  validator:
                                                    validateNoWhitespace,
                                                },
                                              ]}
                                            >
                                              <Input
                                                placeholder={t(
                                                  "placeholder enter gpu",
                                                )}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item
                                              name={[gpuField.name, "card"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "กรุณากรอกจำนวน Card",
                                                },
                                                ({ getFieldValue }: any) => ({
                                                  validator(
                                                    _: any,
                                                    value: any,
                                                  ) {
                                                    const gpus =
                                                      getFieldValue([
                                                        "resources",
                                                        field.name,
                                                        "gpu",
                                                      ]) || [];

                                                    const duplicateCount =
                                                      gpus.filter(
                                                        (item: any) =>
                                                          item?.card !==
                                                            undefined &&
                                                          item?.card === value,
                                                      ).length;

                                                    if (duplicateCount > 1) {
                                                      return Promise.reject(
                                                        new Error(
                                                          "ห้ามกรอกเลข Card ซ้ำกัน",
                                                        ),
                                                      );
                                                    }
                                                    return Promise.resolve();
                                                  },
                                                }),
                                              ]}
                                            >
                                              <InputNumber
                                                min={0}
                                                max={10000000}
                                                placeholder="1"
                                                addonAfter={t("Id")}
                                                {...numberInputProps()}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={2}>
                                            <DeleteButtonWithConfirmsub
                                              onDelete={() =>
                                                gpuOpt.remove(gpuField.name)
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ))}
                                      <Button
                                        onClick={() => gpuOpt.add()}
                                        type="dashed"
                                        icon={<PlusCircleOutlined />}
                                      >
                                        {t("Add GPU")}
                                      </Button>
                                    </div>
                                  )}
                                </Form.List>
                              </Form.Item>
                            </>

                            {/* Delete Machine */}
                            <div style={{ marginTop: 8 }}>
                              <DeleteButtonWithConfirm
                                onDelete={() => {
                                  try {
                                    const v = form.getFieldsValue();
                                    handleDeleteCheckTask(
                                      v.resources[field.key].id,
                                      remove,
                                      field,
                                    );
                                    // remove(field.name);
                                    // setSelectedMachineIndex(
                                    //   Math.max(0, selectedMachineIndex - 1),
                                    // );
                                  } catch (e) {
                                    console.error(e);
                                  }
                                }}
                                fieldKey={field.key}
                              />
                            </div>
                          </div>
                        ))
                      )}
                    </Col>
                  </Row>
                )}
              </Form.List>
            </Card>

            <Row justify="end" style={{ margin: "20px 0px" }}>
              <Popconfirm
                title={t("Confirm data recording")}
                description={t("Confirm data recording detail")}
                onConfirm={async () => {
                  try {
                    await form.validateFields();
                    form.submit();
                  } catch (err: any) {
                    // หา index ของเครื่องแรกที่มี error แล้ว switch ไป
                    const errorFields: string[][] =
                      err?.errorFields?.map((f: any) => f.name) || [];
                    if (errorFields.length > 0) {
                      const firstErrorField = errorFields[0];
                      // field name จะเป็น ["resources", machineIndex, ...]
                      if (
                        firstErrorField[0] === "resources" &&
                        typeof firstErrorField[1] === "number"
                      ) {
                        setSelectedMachineIndex(firstErrorField[1]);
                      }
                    }
                  }
                }}
                okText={t("yes")}
                cancelText={t("no")}
              >
                <Button type="primary" htmlType="button">
                  {t("save")}
                </Button>
              </Popconfirm>
            </Row>
          </Form>
        </Content>
      )}
    </Layout>
  );
};

export default SystemSetting;
